"use client";

import { useMode } from "@demo/hooks/useMode";

import { EXPORTS } from "./registry";

/**
 * Global header island that renders the active mode's export dialog. Each mode
 * self-gates (its component returns `null` when it has no export yet), so the
 * button simply disappears for modes without one — same pattern as `ModeSurface`
 * dispatching surfaces via `SURFACES`.
 */
const ExportButton = () => {
  const [mode] = useMode();
  const Export = EXPORTS[mode];
  return <Export />;
};

export default ExportButton;
